require('./injection/react-native-web');module.exports=require('./ReactPrimitives');